import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Menu, X, BarChart3, Syringe, User, BookOpen, Shield, Info
} from 'lucide-react';
import BrandLogo from './BrandLogo';

const mainNav = [
  { path: '/', label: 'Home', icon: Shield },
  { path: '/#about-episplain-section', label: 'About', icon: Info },
  { path: '/chronic-disease', label: 'Chronic Disease', icon: BarChart3 },
  { path: '/autoimmune', label: 'Autoimmune', icon: Shield },
  { path: '/vaccines', label: 'Vaccines', icon: Syringe },
  { path: '/risk', label: 'You in the Data', icon: User },
  { path: '/learn', label: 'Learn', icon: BookOpen },
];

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 border-b border-violet-200/60 bg-white/80 backdrop-blur-2xl shadow-[0_8px_30px_rgba(76,29,143,0.08)]" data-testid="navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <BrandLogo compact className="pr-3" />

          <div className="hidden lg:flex items-center gap-1 rounded-full border border-violet-100 bg-white/80 px-2 py-2 shadow-sm">
            {mainNav.map((item) => {
              const isActive = item.path.includes('#')
                ? location.pathname === '/' && location.hash === '#about-episplain-section'
                : location.pathname === item.path;
              return (
                <Link key={item.path} to={item.path} data-testid={`nav-link-${item.path.replace('/', '') || 'home'}`}
                  className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-full transition-all ${isActive ? 'bg-gradient-to-r from-violet-700 to-fuchsia-600 text-white shadow-md shadow-violet-900/20' : 'text-slate-600 hover:text-violet-700 hover:bg-violet-50'}`}>
                  <item.icon className="w-4 h-4" /> {item.label}
                </Link>
              );
            })}
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 text-slate-600 hover:text-violet-700 hover:bg-violet-50 rounded-xl" data-testid="mobile-menu-toggle">
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="lg:hidden border-t border-violet-100 bg-white/95 backdrop-blur-xl" data-testid="mobile-menu">
            <div className="px-4 py-3 space-y-1">
              {mainNav.map((item) => (
                <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-2xl transition-colors ${(item.path.includes('#')
                    ? location.pathname === '/' && location.hash === '#about-episplain-section'
                    : location.pathname === item.path) ? 'bg-violet-50 text-violet-700' : 'text-slate-600 hover:bg-violet-50/70'}`}>
                  <item.icon className="w-5 h-5" /> {item.label}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navigation;
